<template>
  <div class="tower_box animate__animated animate__fadeIn">
    <div class="tower">
      <div class="content_list">
        <div class="item_title">
          <div class="bar">设备编号：{{ currentCrane ? currentCrane.number : '' }}</div>
          <div class="bar">运行状态：{{ currentCrane ? fnCraneStatusToText(currentCrane.eqptStatus).msg : '' }}</div>
          <div class="operation">
            <div class="search-btn orange" v-if="currentCrane.isCalibration" @click="fnGetBasicParamConfig"><span>基本设置</span></div>
            <div class="search-btn orange" v-if="currentCrane.isCalibration" @click="showMark = true"><span>标定</span></div>
            <div class="search-btn" @click="fnRefresh"><span>刷新</span></div>
          </div>
        </div>
        <div class="item_box">
          <div class="box" v-if="statusIndex == 0"><Data :currentCrane="currentCrane" /></div>
          <div class="box" v-if="statusIndex == 1"><alarm :currentCrane="currentCrane" /></div>
          <div class="box" v-if="statusIndex == 2"><Hoisting-Record :currentCrane="currentCrane" /></div>
          <div class="box" v-if="statusIndex == 3"><real-time-record :currentCrane="currentCrane"></real-time-record></div>
        </div>
      </div>
      <div class="data_list">
        <div class="title">塔机 ({{ craneData.length }}台)</div>
        <div class="list_title">
          <div class="title_item">设备编号</div>
          <div class="title_item">安装位置</div>
          <div class="title_item">在线状态</div>
        </div>
        <div class="list_box">
          <div v-if="craneData">
            <div class="box_line" v-for="(item, index) in craneData" :key="item.id" @click="fnCraneToggle(item, index)" :class="currentCraneIndex == index ? 'active' : ''">
              <div class="line_item">{{ item.number }}</div>
              <div class="line_item">{{ item.install_location }}</div>
              <div class="line_item">{{ fnOnlineStatusText(item.heartbeatTime).text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog_mark" v-if="showMark">
      <el-dialog :custom-class="'animate__animated animate__fadeIn'" top="20vh" :modal="false" title="标定设置" :visible.sync="showMark" center>
        <div class="mark_content">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="重量" name="1">
              <div class="first_box">
                <div class="box_line">
                  <div class="line_item">
                    <span class="title">实际重量1</span>
                    <el-input v-model="weightInfo.actual1" placeholder="空钩实际重量"></el-input>
                    {{ currentCrane.number.slice(0,1) == 2 ? 'kg' : 't' }}
                  </div>
                  <div class="line_item">
                    <span class="title">实际值1</span>
                    <el-input placeholder="空钩AD值" v-model="weightInfo.calibration1"></el-input>
                  </div>
                  <div class="line_item btn">
                    <div class="search-btn" @click="fnGetCalibrationParam(1, 1)"><span>获 取</span></div>
                  </div>
                </div>
                <div class="box_line">
                  <div class="line_item">
                    <span class="title">实际重量2</span>
                    <el-input v-model="weightInfo.actual2" placeholder="载重实际重量"></el-input>
                    {{ currentCrane.number.slice(0,1) == 2 ? 'kg' : 't' }}
                  </div>
                  <div class="line_item">
                    <span class="title">实际值2</span>
                    <el-input placeholder="载重AD值" v-model="weightInfo.calibration2"></el-input>
                  </div>
                  <div class="line_item btn">
                    <div class="search-btn" @click="fnGetCalibrationParam(1, 2)"><span>获 取</span></div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="高度" name="2">
              <div class="second_box">
                <div class="box_line">
                  <div class="line_item">
                    <span class="title">实际高度1</span>
                    <el-input v-model="heightInfo.actual1" placeholder="吊钩置顶"></el-input>
                    m
                  </div>
                  <div class="line_item">
                    <span class="title">实际值1</span>
                    <el-input placeholder="吊钩置顶AD值" v-model="heightInfo.calibration1"></el-input>
                  </div>
                  <div class="line_item btn">
                    <div class="search-btn" @click="fnGetCalibrationParam(2, 1)"><span>获 取</span></div>
                  </div>
                </div>
                <div class="box_line">
                  <div class="line_item">
                    <span class="title">实际高度2</span>
                    <el-input v-model="heightInfo.actual2" placeholder="吊钩置底"></el-input>
                    m
                  </div>
                  <div class="line_item">
                    <span class="title">实际值2</span>
                    <el-input placeholder="吊钩置底AD值" v-model="heightInfo.calibration2"></el-input>
                  </div>
                  <div class="line_item btn">
                    <div class="search-btn" @click="fnGetCalibrationParam(2, 2)"><span>获 取</span></div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="幅度" name="3">
              <div class="third_box">
                <div class="box_line">
                  <div class="line_item">
                    <span class="title">实际位置1</span>
                    <el-input v-model="rangeInfo.actual1" placeholder="小车至近"></el-input>
                    m
                  </div>
                  <div class="line_item">
                    <span class="title">实际值1</span>
                    <el-input placeholder="小车至近AD值" v-model="rangeInfo.calibration1"></el-input>
                  </div>
                  <div class="line_item btn">
                    <div class="search-btn" @click="fnGetCalibrationParam(3, 1)"><span>获 取</span></div>
                  </div>
                </div>
                <div class="box_line">
                  <div class="line_item">
                    <span class="title">实际位置2</span>
                    <el-input v-model="rangeInfo.actual2" placeholder="小车至远"></el-input>
                    m
                  </div>
                  <div class="line_item">
                    <span class="title">实际值2</span>
                    <el-input placeholder="小车至远AD值" v-model="rangeInfo.calibration2"></el-input>
                  </div>
                  <div class="line_item btn">
                    <div class="search-btn" @click="fnGetCalibrationParam(3, 2)"><span>获 取</span></div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="回转" name="4">
              <div class="fourth_box">
                <div class="box_line">
                  <div class="line_item">
                    <span class="title">实际转角1</span>
                    <el-input v-model="rotationInfo.actual1" placeholder="起始角度"></el-input>
                    度
                  </div>
                  <div class="line_item">
                    <span class="title">实际值1</span>
                    <el-input placeholder="起始AD值" v-model="rotationInfo.calibration1"></el-input>
                  </div>
                  <div class="line_item btn">
                    <div class="search-btn" @click="fnGetCalibrationParam(4, 1)"><span>获 取</span></div>
                  </div>
                </div>
                <div class="box_line">
                  <div class="line_item">
                    <span class="title">实际转角2</span>
                    <el-input v-model="rotationInfo.actual2" placeholder="转向角度"></el-input>
                    度
                  </div>
                  <div class="line_item">
                    <span class="title">实际值2</span>
                    <el-input placeholder="转向AD值" v-model="rotationInfo.calibration2"></el-input>
                  </div>
                  <div class="line_item btn">
                    <div class="search-btn" @click="fnGetCalibrationParam(4, 2)"><span>获 取</span></div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="倾角" name="5">
              <div class="fifth_box">
                <div class="box_line">
                  <div class="line_item">
                    <span class="title">X轴实际角度1</span>
                    <el-input placeholder="点击获取按钮获取" v-model="dipInfo.actual1"></el-input>
                    度
                  </div>
                  <div class="line_item">
                    <span class="title">Y轴实际角度1</span>
                    <el-input placeholder="点击获取按钮获取" v-model="dipInfo.calibration1"></el-input>
                  </div>
                  <div class="line_item btn">
                    <div class="search-btn" @click="fnGetCalibrationParam(5, 1)"><span>获 取</span></div>
                  </div>
                </div>
                <div class="box_line">
                  <div class="line_item">
                    <span class="title">X轴实际角度2</span>
                    <el-input placeholder="点击获取按钮获取" v-model="dipInfo.actual2"></el-input>
                    度
                  </div>
                  <div class="line_item">
                    <span class="title">Y轴实际角度2</span>
                    <el-input placeholder="点击获取按钮获取" v-model="dipInfo.calibration2"></el-input>
                  </div>
                  <div class="line_item btn">
                    <div class="search-btn" @click="fnGetCalibrationParam(5, 2)"><span>获 取</span></div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="btn_line">
            <div class="search-btn red" @click="showMark = false"><span>关 闭</span></div>
            <div class="search-btn" @click="fnSendCalibrationParam"><span>保 存</span></div>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="dialog_setBox" v-if="showSetBox">
      <el-dialog :custom-class="'animate__animated animate__fadeIn'" top="20vh" :close-on-click-modal="false" :modal="false" title="基本配置" :visible.sync="showSetBox" center>
        <div class="set_box">
          <div class="box_line titles">|- 塔机信息</div>
          <div class="box_line">
            <div class="line_item">
              <span class="title">塔机类型</span>
              <el-radio-group v-model="setInfo.type">
                <el-radio :label="0">尖塔</el-radio>
                <el-radio :label="1">平塔</el-radio>
              </el-radio-group>
            </div>
            <div class="line_item">
              <span class="title">塔机型号</span>
              <el-input disabled placeholder="塔机型号" v-model="setInfo.model"></el-input>
            </div>
          </div>
          <div class="box_line">
            <div class="line_item">
              <span class="title">大臂长度(m)</span>
              <el-input placeholder="大臂长度" v-model="setInfo.craneArmLength"></el-input>
            </div>
            <div class="line_item">
              <span class="title">吊绳倍率</span>
              <el-select size="small" class="select_box" v-model="setInfo.slingRatio" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
                <el-option label="请选择" value></el-option>
                <el-option label="2" value="2">2</el-option>
                <el-option label="4" value="4">4</el-option>
                <el-option label="6" value="6">6</el-option>
                <el-option label="8" value="8">8</el-option>
              </el-select>
            </div>
          </div>
          <div class="box_line">
            <div class="line_item">
              <span class="title">平衡臂长</span>
              <el-input placeholder="平衡臂长" v-model="setInfo.balanceArmLength"></el-input>
            </div>
            <div class="line_item">
              <span class="title">最大载重(t)</span>
              <el-input placeholder="最大载重" v-model="setInfo.maxLiftingWeight"></el-input>
            </div>
          </div>
          <div class="box_line">
            <div class="line_item">
              <span class="title">塔帽高度(m)</span>
              <el-input placeholder="塔帽高度" v-model="setInfo.towerHatHeight"></el-input>
            </div>
            <div class="line_item">
              <span class="title">最大力矩(KN*m)</span>
              <el-input placeholder="最大力矩" v-model="setInfo.maxTorque"></el-input>
            </div>
          </div>
          <div class="box_line">
            <div class="line_item">
              <span class="title">塔身高度(m)</span>
              <el-input placeholder="塔身高度" v-model="setInfo.craneArmHeight"></el-input>
            </div>
            <div class="line_item">
              <span class="title">最大风速(m/s)</span>
              <el-input placeholder="最大风速" v-model="setInfo.maxwindSpeed"></el-input>
            </div>
          </div>
          <div class="box_line">
            <div class="line_item">
              <span class="title">系统时间</span>
              <el-input disabled placeholder="系统时间" v-model="setInfo.time"></el-input>
            </div>
            <div class="line_item">
              <span class="title">SIM</span>
              <el-input disabled placeholder="SIM" v-model="setInfo.SIM"></el-input>
            </div>
          </div>
          <div class="box_line titles">|- 安装信息</div>
          <div class="box_line">
            <div class="line_item">
              <span class="title">经度</span>
              <el-input placeholder="经度" v-model="setInfo.installationLongitude"></el-input>
            </div>
            <div class="line_item">
              <div class="search-btn w-80" @click="showMap = true"><span>获取坐标</span></div>
            </div>
          </div>
          <div class="box_line ones">
            <div class="line_item">
              <span class="title">纬度</span>
              <el-input placeholder="纬度" v-model="setInfo.installationLatitude"></el-input>
            </div>
          </div>
          <div class="box_line ones">
            <div class="line_item">
              <span class="title">正北偏转</span>
              <el-input placeholder="正北偏转" v-model="setInfo.dueNorthDeflection"></el-input>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="btn_line">
            <div class="search-btn red" @click="showSetBox = false"><span>关 闭</span></div>
            <div class="search-btn" @click="fnSendBasicParamConfig"><span>保 存</span></div>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="dialog_setMap" v-if="showMap">
      <el-dialog :custom-class="'animate__animated animate__fadeIn'" top="20vh" :close-on-click-modal="false" :modal="false" title="获取经纬度" :visible.sync="showMap" center>
        <div class="show_map"><GDMaps @fnGetLocation="fnGetLocation"></GDMaps></div>
        <div slot="footer" class="dialog-footer">
          <div class="btn_line">
            <div class="search-btn red" @click="showMap = false"><span>关 闭</span></div>
            <div class="search-btn" @click="fnGetLocationYes"><span>确 定</span></div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Data from './components/Data';
import Alarm from './components/Alarm';
import HoistingRecord from './components/HoistingRecord';
import realTimeRecord from './components/realTimeRecord';
import request from '@/utils/request';
import requestEqpt from '@/utils/requestEqpt'; // 相关域名配置见此配置文件说明
import APP from '@/utils/base';
import { getEqptInfo, removeEqptInfo } from '@/utils/auth';
import { getUserInfo } from '@/utils/auth';
import axios from 'axios';
import { getToken } from '@/utils/auth';
import GDMaps from '@/components/Map/location.vue';
export default {
  components: {
    Data,
    Alarm,
    HoistingRecord,
    realTimeRecord,
    GDMaps
  },
  data() {
    return {
      activeName: '1',
      showMark: false,
      showSetBox: false,
      timer: null,
      projectID: '', // 传递过来的项目信息
      statusIndex: 0,
      currentCraneIndex: 0,
      craneData: [], // 塔机列表
      currentCrane: {
        number: '',
        eqptStatus: '',
        id: '',
        nowTime: '',
        isCalibration: null
      }, // 当前设备信息
      isIndex: false,
      indexMsg: null,
      weightInfo: {
        // 重量
        actual1: '', // 实际重量1
        calibration1: '', // 实际值1
        actual2: '', // 实际重量2
        calibration2: '' // 实际值2
      },
      heightInfo: {
        // 高度
        actual1: '', // 实际高度1
        calibration1: '', // 实际值1
        actual2: '', // 实际高度2
        calibration2: '' // 实际值2
      },
      rangeInfo: {
        // 幅度
        actual1: '', // 实际位置1
        calibration1: '', // 实际值1
        actual2: '', // 实际位置2
        calibration2: '' // 实际值2
      },
      rotationInfo: {
        // 回转
        actual1: '', // 实际转角1
        calibration1: '', // 实际值1
        actual2: '', // 实际转角2
        calibration2: '' // 实际值2
      },
      dipInfo: {
        // 倾角
        actual1: '', // x轴实际角度1
        calibration1: '', // y轴实际角度1
        actual2: '', // x轴实际角度2
        calibration2: '' // y轴实际角度2
      },
      setInfo: {
        time: '', //系统时间戳
        type: '', // 塔机类型 0尖塔1平塔
        craneArmLength: '', // 大臂长度 2位小数
        balanceArmLength: '', // 平衡长度 2位小数
        towerHatHeight: '', // 塔帽高度 2位小数
        craneArmHeight: '', // 塔身高度 2位小数
        model: '', // 塔机型号
        slingRatio: '', // 吊绳倍率 2/4/6/8
        maxLiftingWeight: '', // 最大载重 2位小数
        maxTorque: '', // 最大力矩 2位小数
        maxwindSpeed: '', // 最大风速 2位小数
        installationLongitude: '', // 经度 6位小数
        installationLatitude: '', // 纬度 6位小数
        dueNorthDeflection: '', // 正北偏转 2位小数
        SIM: '' // sim
      },
      showMap: false, // 地图坐标拾取
      mapInfo: {
        lng: '',
        lat: ''
      }
    };
  },
  created() {
    let _msg = getEqptInfo();
    if (_msg && _msg.pointType == '塔机设备') {
      this.isIndex = true;
      this.indexMsg = _msg.pointNumber;
    }
    this.projectID = getUserInfo().id;
    this.fnGetCraneList(
      {
        project_id: this.projectID
      },
      res => {
        let _data = res.data.query;
        if (_data.length > 0) {
          this.craneData = _data;
          if (this.isIndex) {
            for (let i in _data) {
              if (_data[i].number == this.indexMsg) {
                this.currentCraneIndex = i;
                this.currentCrane.number = _data[i].number;
                this.currentCrane.eqptStatus = _data[i].eqptStatus;
                this.currentCrane.id = _data[i].id;
                this.currentCrane.isCalibration = _data[i].isCalibration;
                this.currentCrane.nowTime = '' + new Date().getTime();
              }
            }
          } else {
            this.currentCrane.number = _data[0] ? _data[0].number : '';
            this.currentCrane.eqptStatus = _data[0] ? _data[0].eqptStatus : '';
            this.currentCrane.id = _data[0] ? _data[0].id : '';
            this.currentCrane.isCalibration = _data[0].isCalibration ? _data[0].isCalibration : false;
            this.currentCrane.nowTime = '' + new Date().getTime();
          }
        }
      }
    ),
      (this.timer = setInterval(() => {
        this.fnGetCraneList();
      }, 100000));
  },
  beforeDestroy() {
    removeEqptInfo();
    clearInterval(this.timer);
  },
  methods: {
    handleClick(tab, event) {},
    // 查看塔机运行获取
    fnOpenCraneRealTimeRecord() {
      this.statusIndex = 3;
    },
    // 查看塔机预报警次数
    fnOpenCraneAlarm() {
      this.statusIndex = 1;
    },
    // 查看吊装获取
    fnOpenHoistingRecord() {
      this.statusIndex = 2;
    },
    // 查看实时数据
    fnOpenHome() {
      this.statusIndex = 0;
    },
    // 获取切换
    fnStatusToggle(_el) {
      let _index = _el.target.dataset.index;
      if (_index != this.statusIndex) {
        this.statusIndex = _index;
      }
    },
    // 获取塔机列表
    fnGetCraneList(_obj, _cb) {
      request({
        notLoading: true,
        url: '/crane/get',
        method: 'GET',
        params: _obj
      })
        .then(res => {
          _cb && _cb(res);
        })
        .catch(err => {
          this.$message.error(err.data);
        });
    },
    // 塔机运行状态
    fnCraneStatusToText(_status) {
      return APP.fnCraneStatusToText(_status, 'crane');
    },
    // 获取选中塔机信息
    fnCraneToggle(_item, _index) {
      this.currentCraneIndex = _index;
      this.fnGetCraneList(
        {
          number: _item.number
        },
        res => {
          let _data = res.data.query;
          if (_data.length > 0) {
            this.currentCrane.number = _data[0] ? _data[0].number : '';
            this.currentCrane.eqptStatus = _data[0] ? _data[0].eqptStatus : '';
            this.currentCrane.id = _data[0] ? _data[0].id : '';
            this.currentCrane.isCalibration = _data[0].isCalibration ? _data[0].isCalibration : false;
            this.currentCrane.nowTime = '' + new Date().getTime();
          }
        }
      );
    },
    // 塔机在线状态
    fnOnlineStatusText(_heartbeatTime) {
      return APP.fnOnlineStatusText(_heartbeatTime);
    },
    // 刷新
    fnRefresh() {
      if (this.craneData.length > 0) {
        this.fnCraneToggle(this.craneData[this.currentCraneIndex], this.currentCraneIndex);
      }
    },
    // 获取标定
    fnGetCalibrationParam(type, index) {
      let _obj = {
        number: this.currentCrane.number,
        type: type
      };
      requestEqpt({
        notLoading: true,
        url: '/getCalibrationParam',
        method: 'GET',
        params: _obj
      })
        .then(res => {
          this.fnSetInfo(this.currentCrane.number,type, index, res);
        })
        .catch(err => {
          this.$message.error(err.data);
        });
    },
    // 获取完获取以后设置到页面
    fnSetInfo(number,type, index, res) {
      // 判断设备号为2开头的不除以 1000000
      let _jz = number.slice(0,1) == 2
      switch (type) {
        case 1:
          index == 1 ? (this.weightInfo.calibration1 = _jz ? res.data : (res.data / 1000000)) : (this.weightInfo.calibration2 = _jz ? res.data : (res.data / 1000000));
          break;
        case 2:
          index == 1 ? (this.heightInfo.calibration1 = _jz ? res.data : (res.data / 1000000)) : (this.heightInfo.calibration2 = _jz ? res.data : (res.data / 1000000));
          break;
        case 3:
          index == 1 ? (this.rangeInfo.calibration1 = _jz ? res.data : (res.data / 1000000)) : (this.rangeInfo.calibration2 = _jz ? res.data : (res.data / 1000000));
          break;
        case 4:
          index == 1 ? (this.rotationInfo.calibration1 = _jz ? res.data : (res.data / 1000000)) : (this.rotationInfo.calibration2 = _jz ? res.data : (res.data / 1000000));
          break;
        case 5:
          if (index == 1) {
            this.dipInfo.actual1 = _jz ? res.data.x : (res.data.x / 1000000);
            this.dipInfo.calibration1 = _jz ? res.data.y : (res.data.y / 1000000);
          } else {
            this.dipInfo.actual2 = _jz ? res.data.x : (res.data.x / 1000000);
            this.dipInfo.calibration2 = _jz ? res.data.y : (res.data.y / 1000000);
          }
          break;
        default:
          break;
      }
    },
    // 保存 标定
    fnSendCalibrationParam() {
      let _obj = {};
      switch (parseInt(this.activeName)) {
        case 1: // 重量
          let num1 = 0;
          for (let i in this.weightInfo) {
            num1 += 1;
            if (this.weightInfo[i] === '') {
              let _index = num1 == 1 ? 1 : num1 == 2 ? 1 : num1 == 3 ? 2 : 2;
              let _s = num1 % 2 != 0 ? '重量' + _index : '值' + _index;
              let _str = '实际' + _s + '不能为空';
              return this.$message.warning(_str);
            }
          }
          _obj = JSON.parse(JSON.stringify(this.weightInfo));
          break;
        case 2: // 高度
          let num2 = 0;
          for (let i in this.heightInfo) {
            num2 += 1;
            if (this.heightInfo[i] === '') {
              let _index = num2 == 1 ? 1 : num2 == 2 ? 1 : num2 == 3 ? 2 : 2;
              let _s = num2 % 2 != 0 ? '高度' + _index : '值' + _index;
              let _str = '实际' + _s + '不能为空';
              return this.$message.warning(_str);
            }
          }
          _obj = JSON.parse(JSON.stringify(this.heightInfo));
          break;
        case 3: // 幅度
          let num3 = 0;
          for (let i in this.rangeInfo) {
            num3 += 1;
            if (this.rangeInfo[i] === '') {
              let _index = num3 == 1 ? 1 : num3 == 2 ? 1 : num3 == 3 ? 2 : 2;
              let _s = num3 % 2 != 0 ? '位置' + _index : '值' + _index;
              let _str = '实际' + _s + '不能为空';
              return this.$message.warning(_str);
            }
          }
          _obj = JSON.parse(JSON.stringify(this.rangeInfo));
          break;
        case 4: // 回转
          let num4 = 0;
          for (let i in this.rotationInfo) {
            num4 += 1;
            if (this.rotationInfo[i] === '') {
              let _index = num4 == 1 ? 1 : num4 == 2 ? 1 : num4 == 3 ? 2 : 2;
              let _s = num4 % 2 != 0 ? '转角' + _index : '值' + _index;
              let _str = '实际' + _s + '不能为空';
              return this.$message.warning(_str);
            }
          }
          _obj = JSON.parse(JSON.stringify(this.rotationInfo));
          break;
        case 5: // 倾角
          let num5 = 0;
          for (let i in this.dipInfo) {
            num5 += 1;
            if (this.dipInfo[i] === '') {
              let _index = num5 == 1 ? 1 : num5 == 2 ? 1 : num5 == 3 ? 2 : 2;
              let _s = num5 % 2 != 0 ? 'X轴实际角度' + _index : 'Y轴实际角度' + _index;
              let _str = _s + '不能为空';
              return this.$message.warning(_str);
            }
          }
          _obj = JSON.parse(JSON.stringify(this.dipInfo));
          break;
        default:
          break;
      }
      // 判断设备号为2开头的不乘 1000000
      let _jz = this.currentCrane.number.slice(0,1) == 2
      if(!_jz){
        for (let i in _obj) {
          _obj[i] = '' + _obj[i] * 1000000;
        }
      }
      _obj.type = this.activeName;
      _obj.number = this.currentCrane.number;
      if (this.activeName != 5) {
        let _str = this.activeName == 1 ? '重量' : this.activeName == 2 ? '高度' : this.activeName == 3 ? '幅度' : this.activeName == 4 ? '回转' : '倾角';
        if (_obj.actual1 == _obj.actual2) return this.$message.warning('两个实际' + _str + '值不能相同！');
        if (_obj.calibration1 == _obj.calibration2) return this.$message.warning('两个实际值不能相同！');
      }
      // 为请求头为 application/x-www-form-urlencoded 转换数据
      let param = new URLSearchParams();
      param.append('type', _obj.type);
      param.append('number', _obj.number);
      param.append('actual1', _obj.actual1);
      param.append('calibration1', _obj.calibration1);
      param.append('actual2', _obj.actual2);
      param.append('calibration2', _obj.calibration2);
      requestEqpt({
        url: '/sendCalibrationParam',// 具体操作见配置文件
        method: 'POST',
        data: param
      })
        .then(res => {
          let _str = this.activeName == 1 ? '重量' : this.activeName == 2 ? '高度' : this.activeName == 3 ? '幅度' : this.activeName == 4 ? '回转' : '倾角';
          this.$message.success(_str + res.data);
        })
        .catch(err => {
          this.$message.error(err.data);
        });
    },
    // 获取基本配置
    fnGetBasicParamConfig() {
      requestEqpt({
        notLoading: true,
        url: '/getBasicParamConfig',
        method: 'GET',
        params: {
          number: this.currentCrane.number
        }
      })
        .then(res => {
          let _data = res.data;
          this.setInfo.time = this.fnGetTime(_data.time * 1000); //系统时间戳
          this.setInfo.type = _data.type; // 塔机类型 0尖塔1平塔
          this.setInfo.craneArmLength = _data.craneArmLength / 100; // 大臂长度 2位小数
          this.setInfo.balanceArmLength = _data.balanceArmLength / 100; // 平衡长度 2位小数
          this.setInfo.towerHatHeight = _data.towerHatHeight / 100; // 塔帽高度 2位小数
          this.setInfo.craneArmHeight = _data.craneArmHeight / 100; // 塔身高度 2位小数
          this.setInfo.model = _data.model; // 塔机型号
          this.setInfo.slingRatio = _data.slingRatio; // 吊绳倍率 2/4/6/8
          this.setInfo.maxLiftingWeight = _data.maxLiftingWeight / 100; // 最大载重 2位小数
          this.setInfo.maxTorque = _data.maxTorque / 100; // 最大力矩 2位小数
          this.setInfo.maxwindSpeed = _data.maxwindSpeed / 100; // 最大风速 2位小数
          this.setInfo.installationLongitude = _data.installationLongitude / 1000000; // 经度 6位小数
          this.setInfo.installationLatitude = _data.installationLatitude / 1000000; // 纬度 6位小数
          this.setInfo.dueNorthDeflection = _data.dueNorthDeflection / 100; // 正北偏转 2位小数
          this.setInfo.SIM = _data.SIM;
          this.showSetBox = true;
        })
        .catch(err => {
          this.$message.error(err.data);
        });
    },
    // 时间转换
    fnGetTime(_time) {
      let now = new Date(_time);
      let year = now.getFullYear();
      let month = now.getMonth() + 1; //得到月份
      let date = now.getDate(); //得到日期
      let hour = now.getHours(); //得到小时
      let minu = now.getMinutes(); //得到分钟
      let sec = now.getSeconds(); //得到秒
      if (month < 10) month = '0' + month;
      if (date < 10) date = '0' + date;
      if (hour < 10) hour = '0' + hour;
      if (minu < 10) minu = '0' + minu;
      if (sec < 10) sec = '0' + sec;
      let time = '';
      time = year + '-' + month + '-' + date + ' ' + hour + ':' + minu + ':' + sec;
      return time;
    },
    // 保存基本配置
    fnSendBasicParamConfig() {
      let _needField = {
        type: '塔机类型',
        craneArmLength: '大臂长度', // 2位小数
        balanceArmLength: '平衡长度', // 2位小数
        towerHatHeight: '塔帽高度', // 2位小数
        craneArmHeight: '塔身高度', // 2位小数
        model: '塔机型号',
        slingRatio: '吊绳倍率', // 2/4/6/8
        maxLiftingWeight: '最大载重', // 2位小数
        maxTorque: '最大力矩', // 2位小数
        maxwindSpeed: '最大风速', // 2位小数
        installationLongitude: '经度', // 6位小数
        installationLatitude: '纬度', // 6位小数
        dueNorthDeflection: '正北偏转' // 2位小数
      };
      for (let _key in _needField) {
        if (this.setInfo[_key] === null || this.setInfo[_key] === '' || this.setInfo[_key] === undefined) {
          this.$message.warning(_needField[_key] + '不能为空');
          return;
        }
      }
      let _obj = JSON.parse(JSON.stringify(this.setInfo));
      let _jz = this.currentCrane.number.slice(0,1) == 2 // 如果是巨正 保存时（大臂长度，平衡臂长，塔帽高度，塔身高度，吊绳倍率，最大载重，最大风速）乘10 否则乘100
      // 为请求头为 application/x-www-form-urlencoded 转换数据
      let param = new URLSearchParams();
      param.append('number', this.currentCrane.number);
      param.append('type', _obj.type); // 塔机类型
      param.append('craneArmLength', _obj.craneArmLength * (_jz ? 10 : 100)); // 大臂长度
      param.append('balanceArmLength', _obj.balanceArmLength * (_jz ? 10 : 100)); // 平衡长度
      param.append('towerHatHeight', _obj.towerHatHeight * (_jz ? 10 : 100)); // 塔帽高度
      param.append('craneArmHeight', _obj.craneArmHeight * (_jz ? 10 : 100)); // 塔身高度
      param.append('model', _obj.model); // 塔机型号
      param.append('slingRatio', _obj.slingRatio * (_jz ? 0.1 : 1)); // 吊绳倍率
      param.append('maxLiftingWeight', _obj.maxLiftingWeight * (_jz ? 10 : 100)); // 最大载重
      param.append('maxTorque', _obj.maxTorque * 100); // 最大力矩
      param.append('maxwindSpeed', _obj.maxwindSpeed * (_jz ? 10 : 100)); // 最大风速
      param.append('installationLongitude', _obj.installationLongitude * 1000000); // 经度
      param.append('installationLatitude', _obj.installationLatitude * 1000000); // 纬度
      param.append('dueNorthDeflection', _obj.dueNorthDeflection * 100); // 正北偏转

      requestEqpt({ // 具体操作见配置文件
        url: '/sendBasicParamConfig',
        method: 'POST',
        data: param,
      })
        .then(res => {
          this.$message.success(res.data);
          this.showSetBox = false;
        })
        .catch(err => {
          this.$message.error(err.data);
        });
    },
    // 跳转坐标拾取 子传父
    fnGetLocation(lng, lat) {
      this.mapInfo.lng = lng;
      this.mapInfo.lat = lat;
    },
    // 确认选择的经纬度 关闭弹窗
    fnGetLocationYes() {
      this.setInfo.installationLongitude = this.mapInfo.lng;
      this.setInfo.installationLatitude = this.mapInfo.lat;
      this.showMap = false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.elevator_box {
  width: 1920px;
  height: 858px;
  position: relative;
  overflow: hidden;
  .elevator {
    position: absolute;
    left: 0;
    right: -20px;
    top: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
.content_list {
  position: absolute;
  top: 0;
  left: 0;
  width: 1600px;
  height: 858px;
  .item_title {
    width: 1580px;
    height: 60px;
    margin: 10px;
    position: relative;
    background: url(../../../assets/img/per_list_bg.png) no-repeat;
    background-size: 100% 100%;
    @include flex-box(flex-start, center);
  }
  .bar {
    font-size: 20px;
    margin: 0 20px;
  }
  .operation {
    position: absolute;
    right: 10px;
    @include flex-box();
  }
  .item_box {
    width: 1600px;
    height: 778px;
  }
}
.data_list {
  position: absolute;
  top: 0;
  left: 1620px;
  width: 300px;
  height: 848px;
  margin-top: 10px;
  background-color: rgba(29, 68, 149, 0.1);
  .title {
    width: 300px;
    height: 60px;
    font-size: 24px;
    background: url(../../../assets/img/per_list_bg.png) no-repeat;
    background-size: 100% 100%;
    @include flex-box(center, center);
  }
  .list_title {
    width: 300px;
    height: 48px;
    background: url(../../../assets/img/enter_left_bg.png) no-repeat;
    background-size: 100% 100%;
    @include flex-box(flex-start, center);
    .title_item {
      width: 96px;
      margin: 0 2px;
      text-align: center;
    }
  }
  .list_box {
    width: 300px;
    height: 740px;
    .box_line {
      width: 300px;
      height: 48px;
      cursor: pointer;
      border-bottom: 1px dashed #1d4495;
      @include flex-box(center, center);
      &.active {
        color: #0080ff;
      }
      .line_item {
        width: 96px;
        margin: 0 2px;
        text-align: center;
      }
    }
  }
}

>>> .el-pager .more:before {
  content: '\E794';
}
>>> .el-switch.is-checked .el-switch__core:after {
  content: '';
}
.dialog_mark,
.dialog_setBox,
.dialog_setMap {
  >>> .el-dialog {
    width: 720px;
    height: 470px;
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  >>> .el-dialog__body {
    padding: 10px;
    height: 360px;
  }
  >>> .el-form-item__label {
    color: #4db4f4;
  }
  >>> .el-dialog__title {
    color: #4db4f4;
  }
  >>> .el-dialog__close {
    color: #4db4f4;
  }
  .btn_line {
    @include flex-box(center, center);
  }
  .mark_content {
    width: 700px;
    height: 340px;
    color: #4db4f4;
    >>> .el-tabs__item {
      color: #ffffff;
    }
    >>> .el-tabs__item.is-active {
      color: #409eff;
    }
    .first_box,
    .second_box,
    .third_box,
    .fourth_box,
    .fifth_box {
      width: 700px;
      height: 280px;
      @include flex-box(flex-start, center, column);
      .box_line {
        width: 700px;
        height: 50px;
        line-height: 50px;
        @include flex-box(space-around, center);
        .line_item {
          width: 310px;
          &.btn {
            width: 80px;
          }
          .title {
            display: inline-block;
            width: 100px;
          }
          >>> .el-input {
            width: 170px;
          }
          >>> .el-input__inner {
            width: 170px;
            height: 30px;
            line-height: 30px;
            padding-left: 15px;
            color: rgba(77, 180, 244, 0.7);
            font-size: 12px;
            border: 0;
            outline: none;
            background-color: rgba(49, 88, 128, 0.4);
            &::-webkit-input-placeholder {
              color: rgba(77, 180, 244, 0.7);
            }
            &::-moz-placeholder {
              /* Mozilla Firefox 19+ */
              color: rgba(77, 180, 244, 0.7);
            }
            &:-moz-placeholder {
              /* Mozilla Firefox 4 to 18 */
              color: rgba(77, 180, 244, 0.7);
            }
            &:-ms-input-placeholder {
              /* Internet Explorer 10-11 */
              color: rgba(77, 180, 244, 0.7);
            }
          }
        }
      }
    }
  }
}
.dialog_setBox {
  >>> .el-dialog {
    width: 720px;
    height: 570px;
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  >>> .el-dialog__body {
    padding: 10px;
    height: 460px;
  }
  .set_box,
  .show_map {
    width: 700px;
    height: 440px;
    color: #4db4f4;
    .box_line {
      width: 700px;
      height: 40px;
      line-height: 40px;
      @include flex-box(space-around, center);
      &.titles {
        margin-left: 5px;
        font-size: 16px;
        @include flex-box(flex-start, center);
      }
      &.ones {
        margin-left: 5px;
        @include flex-box(flex-start, center);
      }
      .line_item {
        width: 340px;
        .title {
          display: inline-block;
          width: 120px;
        }
        >>> .el-input {
          width: 215px;
        }
        >>> .el-input__inner {
          width: 215px;
          height: 30px;
          line-height: 30px;
          padding-left: 15px;
          color: rgba(77, 180, 244, 0.7);
          font-size: 12px;
          border: 0;
          outline: none;
          background-color: rgba(49, 88, 128, 0.4);
          &::-webkit-input-placeholder {
            color: rgba(77, 180, 244, 0.7);
          }
          &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: rgba(77, 180, 244, 0.7);
          }
          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: rgba(77, 180, 244, 0.7);
          }
          &:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: rgba(77, 180, 244, 0.7);
          }
        }
      }
    }
  }
}
.dialog_setMap {
  >>> .el-dialog {
    width: 720px;
    height: 620px;
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  >>> .el-dialog__body {
    padding: 10px;
    height: 510px;
  }
  .show_map {
    width: 700px;
    height: 490px;
    z-index: 100;
    overflow: hidden;
    color: #4db4f4;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Tower/towerDefault/index.vue